/**
 * References Page - Counter Animations & Smooth Scroll
 */

class ReferencesCounters {
  constructor() {
    this.counters = document.querySelectorAll('.stat-counter');
    this.scrollBtn = document.querySelector('.ref-hero__scroll');
    this.animated = false;
    this.locale = (document?.documentElement?.lang || navigator?.language || 'tr-TR').trim() || 'tr-TR';

    if (this.counters.length) {
      this.initCounters();
    }

    if (this.scrollBtn) {
      this.initSmoothScroll();
    }
  }

  initCounters() {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !this.animated) {
          this.animateCounters();
        }
      });
    }, { threshold: 0.3 });

    const statsSection = document.querySelector('.ref-hero__stats');
    if (statsSection) {
      observer.observe(statsSection);
    }
  }

  animateCounters() {
    this.counters.forEach(counter => {
      const target = parseInt(counter.getAttribute('data-target'));
      const duration = 2500;
      const frameDuration = 1000 / 60;
      const totalFrames = Math.round(duration / frameDuration);
      let frame = 0;

      const easeOutQuart = t => 1 - Math.pow(1 - t, 4);

      const updateCounter = () => {
        frame++;
        const progress = easeOutQuart(frame / totalFrames);
        const currentCount = Math.round(target * progress);

        counter.textContent = currentCount.toLocaleString(this.locale);

        if (frame < totalFrames) {
          requestAnimationFrame(updateCounter);
        } else {
          counter.textContent = target.toLocaleString(this.locale);
        }
      };

      updateCounter();
    });

    this.animated = true;
  }

  initSmoothScroll() {
    this.scrollBtn.addEventListener('click', () => {
      const target = document.querySelector('.ref-main');
      if (target) {
        target.scrollIntoView({
          behavior: 'smooth'
        });
      }
    });
  }
}

export default ReferencesCounters;
